import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs';
import { ConfigService } from './configService';

export interface PdfResponse {
    content: ArrayBuffer | null,
    name: string
}

@Injectable()
export class PdfReportService {
    private baseUrl: string;
    protected headers: HttpHeaders;

    constructor(
        private httpClient: HttpClient,
        private config: ConfigService,
    ) {
        this.baseUrl = this.config.get('apiUrl') + '/v1/report/pdf';
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json',
        });
    }

    public getProposalPdf(qnum: number, qsuffix: string) {
        return this.httpClient.get(
            `${this.baseUrl}/full/${qnum}/${qsuffix}`,
            {
                headers: this.headers,
                observe: 'response',
                responseType: 'arraybuffer',
            }
        ).pipe(
            map((r) => {
                const type = r.headers.get('Content-Type');
                return {
                    content: r.body,
                    mime: type,
                };
            })
        );
    }

    public getVehiclesPdf(qnum: number, qsuffix: string) {
        return this.httpClient.get(`${this.baseUrl}/vehicles/${qnum}/${qsuffix}`, {
            headers: this.headers,
            observe: 'response',
            responseType: 'arraybuffer',
        }).pipe(
            map((r) => {
                const type = r.headers.get('Content-Type');
                return {
                    content: r.body,
                    mime: type,
                };
            })
        );
    }

    public getVehiclePdf(qnum: number, qsuffix: string, id: number) {
        return this.httpClient.get(`${this.baseUrl}/vehicles/${qnum}/${qsuffix}/${id}`, {
            headers: this.headers,
            observe: 'response',
            responseType: 'arraybuffer',
        }).pipe(
            map((r) => {
                const type = r.headers.get('Content-Type');
                return {
                    content: r.body,
                    mime: type,
                };
            })
        );
    }
}